<template>
    <div class="form-content-wrapper">
        <h6 class="form-title mb-1">PIHAK LAIN (Keluarga yang Tidak Serumah)</h6>
        <div class="text-muted smallText mb-3">* Hanya wajib diisi BILA anggota ingin menggadaikan BPKB</div>
        <b-row>
            <b-col lg="4" md="6">
                <b-form-group>
                    <label for="pihakLainNama">Nama <span v-if="!vDataPihakLain.namaPihakLain.required && vDataPihakLain.namaPihakLain.$dirty" class="text-danger">Kolom tidak boleh kosong</span></label>
                    <b-form-input v-model="dataPihakLain.namaPihakLain" name="pihakLainNama" placeholder="Ketik Nama"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group>
                    <label for="pihakLainHubungan">Hubungan <span v-if="!vDataPihakLain.hubunganPihakLain.required && vDataPihakLain.hubunganPihakLain.$dirty" class="text-danger">Kolom tidak boleh kosong</span></label>
                    <b-form-input v-model="dataPihakLain.hubunganPihakLain" name="pihakLainHubungan" placeholder="Ketik Hubungan"></b-form-input>
                </b-form-group>
            </b-col>
            <!-- <b-col lg="4" md="6">
                <b-form-group label="Telp Rumah">
                    <b-form-input v-model="dataPihakLain.teleponRumahPihakLain" name="pihakLainTelprumah"></b-form-input>
                </b-form-group>
            </b-col> -->
            <b-col lg="4" md="6">
                <b-form-group>
                    <label for="pihakLainNohp">No Handphone <span v-if="!vDataPihakLain.noHandphonePihakLain.required && vDataPihakLain.noHandphonePihakLain.$dirty" class="text-danger">Kolom tidak boleh kosong</span></label>
                    <b-form-input v-model="dataPihakLain.noHandphonePihakLain" name="pihakLainNohp" placeholder="Ketik No Telepon"></b-form-input>
                </b-form-group>
            </b-col>
            <!-- <b-col lg="4" md="6">
                <b-form-group label="Telp Kantor">
                    <b-form-input v-model="dataPihakLain.teleponKantorPihakLain" name="pihakLainTelpkantor"></b-form-input>
                </b-form-group>
            </b-col> -->
            <b-col lg="4" md="6">
                <b-form-group label="Kota">
                    <div class="d-flex">
                        <multiselect
                            name="pihakLainKota"
                            v-model="dataPihakLain.kotaPihakLain" 
                            :options="kota" 
                            :internal-search="false"
                            :loading="isLoading"
                            @search-change="search"
                            :allow-empty="false"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="name"
                            placeholder="*Ketik min. 4 huruf untuk mencari..."
                        />
                    </div>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Kecamatan">
                    <b-input-group >
                        <b-form-select  v-if="dataPihakLain.kecLoading == true" v-model="data" name="pihakLainKecamatan" disabled>
                            <template v-slot:first>
                                <b-form-select-option value="null" disabled>Mengambil data ...</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-select v-else v-model="dataPihakLain.kecamatanPihakLain" name="pihakLainKecamatan" :options="dataPihakLain.listKecamatan" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" required disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-input-group-append v-if="dataPihakLain.loadKecFail == true">
                            <b-button variant="primary" size="sm" @click="loadKecamatan"><i class="fa fa-refresh"></i></b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group>
                    <label for="pihakLainKelurahan">Kelurahan <span v-if="!vDataPihakLain.kelurahanDesaPihakLain.required && vDataPihakLain.kelurahanDesaPihakLain.$dirty" class="text-danger">Kolom tidak boleh kosong</span></label>
                    <b-input-group>
                        <b-form-select v-if="dataPihakLain.kelLoading == true" v-model="data" name="pihakLainKelurahan" disabled>
                            <template v-slot:first>
                                <b-form-select-option value="null" disabled>Mengambil data ...</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-select v-else v-model="dataPihakLain.kelurahanDesaPihakLain" name="pihakLainKelurahan" :options="dataPihakLain.listKelurahan" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-input-group-append v-if="dataPihakLain.loadKelFail == true">
                            <b-button variant="primary" size="sm" @click="loadKelurahan"><i class="fa fa-refresh"></i></b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6" class="form-tworow-wrapper" >
                <b-row>
                    <b-col cols="6">
                        <b-form-group>
                            <label for="pihakLainNort">RT 
                                <span v-if="!vDataPihakLain.rtPihakLain.required && vDataPihakLain.rtPihakLain.$dirty" class="text-danger">Kolom tidak boleh kosong</span>
                                <span v-if="!vDataPihakLain.rtPihakLain.minLength && vDataPihakLain.rtPihakLain.$dirty" class="text-danger">Gunakan format 3 angka, contoh: 001</span></label>
                            <b-form-input v-model="dataPihakLain.rtPihakLain" name="pihakLainNort" maxlength="3" title="Gunakan format 3 angka (contoh: 001)" placeholder="Ketik RT"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group>
                            <label for="pihakLainNorw">RW 
                                <span v-if="!vDataPihakLain.rwPihakLain.required && vDataPihakLain.rwPihakLain.$dirty" class="text-danger">Kolom tidak boleh kosong </span>
                                <span v-if="!vDataPihakLain.rwPihakLain.minLength && vDataPihakLain.rwPihakLain.$dirty" class="text-danger">Gunakan format 3 angka, contoh: 001</span></label>
                            <b-form-input v-model="dataPihakLain.rwPihakLain" name="pihakLainNorw" maxlength="3" title="Gunakan format 3 angka (contoh: 001)" placeholder="Ketik RW"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group>
                    <label for="pihakLainAlamat">Alamat Sekarang <span v-if="!vDataPihakLain.alamatPihakLain.required && vDataPihakLain.alamatPihakLain.$dirty" class="text-danger">Kolom tidak boleh kosong</span></label>
                    <b-form-textarea v-model="dataPihakLain.alamatPihakLain" name="pihakLainAlamat" placeholder="Ketik Alamat Sekarang" maxlength="255"></b-form-textarea>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button name="identitasResetBtn" variant="danger" @click="$emit('reset')">Reset Pihak Lain</b-button>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'data-pihak-lain',
    props: {
        dataPihakLain: { type: Object, required: true },
        dataRequired: { type: Boolean},
        vDataPihakLain: { type: Object, required: true },
    },
    data(){
        return{
            isLoading: false,
            activeSearch: null,
            data: null,
            kota: []
        }
    }, 
    watch: {
        "dataPihakLain.rtPihakLain": function(newValue) {
            const result = newValue.replace(/[^\d]/g,'');
            this.$nextTick(() => this.dataPihakLain.rtPihakLain = result);
        },
        "dataPihakLain.rwPihakLain": function(newValue) {
            const result = newValue.replace(/[^\d]/g,'');
            this.$nextTick(() => this.dataPihakLain.rwPihakLain = result);
        },
    },
    methods: {
        search(searchQuery){
            if (searchQuery.length >= 4){
                this.isLoading = true

                if (this.activeSearch == null) this.activeSearch = setTimeout(() => { this.searchKota(searchQuery) }, 1000)
                else {
                    clearTimeout(this.activeSearch)
                    this.activeSearch = setTimeout(() => { this.searchKota(searchQuery) }, 1000)
                }
            } 
            else {
                clearTimeout(this.activeSearch)
                this.activeSearch = null
                this.isLoading = false
            }
        },

        searchKota(searchQuery){ 
            this.$axios.get('area/search/kota/?name='+searchQuery).then(response => {
                this.kota = response.data
                this.isLoading = false
                this.activeSearch = null
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        },

        loadKecamatan(){
            this.dataPihakLain.kecLoading = true
            this.dataPihakLain.loadKecFail = false

            this.$axios.get(`area/kecamatan/${this.dataPihakLain.kotaKtp.id}`).then(response => {
                this.dataPihakLain.listKecamatan = response.data
                this.dataPihakLain.kecLoading = false
            })
            .catch(error => {
                console.log(error)
                this.input.dataPihakLain.loadKecFail = true

                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        },

        loadKelurahan(){
            this.dataPihakLain.kelLoading = true
            this.dataPihakLain.loadKelFail = false

            this.$axios.get(`area/kelurahan/${this.dataPihakLain.kecamatanKtp}`).then(response => {
                this.dataPihakLain.listKelurahan = response.data
                this.dataPihakLain.kelLoading = false
            })
            .catch(error => {
                console.log(error)
                this.input.dataPihakLain.loadKelFail = true

                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        }
    },
}
</script>
